import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSubmitIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M92.6649 3.87831C92.0857 3.39743 91.3818 3.09105 90.6352 2.99488C89.8885 2.89872 89.1299 3.01672 88.4478 3.33515L6.58936 41.7578V49.1926L40.9716 62.9453L63.0255 96.875H70.4618L93.9579 7.92968C94.1484 7.20126 94.128 6.43371 93.8991 5.71644C93.6702 4.99916 93.2422 4.3617 92.6649 3.87831ZM65.8706 89.7838L46.9142 60.6191L76.0847 28.6695L71.4692 24.4555L42.0704 56.6541L13.7222 45.3148L86.6603 11.0781L65.8706 89.7838Z",
		fill: "#777777"
	})
});
export default SvgSubmitIcon;
